import React, { useState, useEffect, useRef } from 'react';
import { useAddNewNamirnicuMutation,useUpdateNamirnicuMutation,useGetAllNamirniceQuery,useDeleteNamirnicuMutation } from '../features/Namirnice/namirniceApiSlice';
import { useGetIshraneNamesQuery } from '../features/ishrana/ishranaApiSlice';
import { useGetAllSpecCiljNamesQuery } from '../features/ciljevi/ciljeviApiSlice';

const initialNamirnice = [ 
  { id: 1, naziv: "Limun", grupa: "Voće", podtip: "Citrus", laktoza: false, gluten: false, alergen: false, ishrane: ["Veganska"] },
  { id: 2, naziv: "Kikiriki", grupa: "Orašasti Plodovi", podtip: "Orašasti Plodovi", laktoza: false, gluten: false, alergen: true, ishrane: ["Paleo"] },
];

const NamirnicaForm = () => {
  const [naziv, setNaziv] = useState("");
  const [laktoza, setLaktoza] = useState(false);
  const [gluten, setGluten] = useState(false);
  const [alergen, setAlergen] = useState(false);
  const [grupa, setGrupa] = useState("");
  const [podtip, setPodtip] = useState("");
  const [odabraneIshrane, setOdabraneIshrane] = useState([]);
  const [odabraniCiljevi, setOdabraniCiljevi] = useState([]);
  const [namirnice, setNamirnice] = useState([]);
  const [editNamirnicaId, setEditNamirnicaId] = useState(null);
  const [isPopupOpen, setIsPopupOpen] = useState(false); // Popup za kreiranje/izmenu namirnice
  const [isModalOpen, setIsModalOpen] = useState(false); // Modal za potvrdu brisanja
  const [namirnicaZaBrisanje, setNamirnicaZaBrisanje] = useState(null); // ID namirnice za brisanje
  const popupRef = useRef(null);
  const [IdNam, setIdNam] = useState(null);
  const [availableIshrane, setAvailableIshrane] = useState([]);
  const [availableCiljevi, setAvailableCiljevi] = useState([]); //Misli se na specificne ciljeve

  //Hookovi
  const { isSuccess: isSuccessGetNamir, isError: isErrorGetNamir, error: getNamirError, data: getNamirData } = useGetAllNamirniceQuery();
  const [addNamir, { isSuccess: isSuccessAddNamir, isError: isErrorAddNamir, error: errorAddNamir, data: dataAddNamir }] = useAddNewNamirnicuMutation();
  const [updateNamir, { isSuccess: isSuccessUpdateNamir, isError: isErrorUpdateNamir, error: errorUpdateNamir, data: dataUpdateNamir }] = useUpdateNamirnicuMutation();
  const [delNamir, { isSuccess: isSuccessDelNamir, isError: isErrorDelNamir, error: errorDelNamir, data: dataDelNamir }] = useDeleteNamirnicuMutation();
  
  //names ishrane
  const { isSuccess: isSuccessGetIshName, isError: isErrorGetIshName, error: getIshNameError, data: getIshNameData } = useGetIshraneNamesQuery();

  //names spec cilj
  const { isSuccess: isSuccessGetSpecCiljName, isError: isErrorGetSpecCiljName, error: getSpecCiljNameError, data: getSpecCiljNameData } = useGetAllSpecCiljNamesQuery();
  

  //Get Namirnice
  useEffect(() => {
    if (isSuccessGetNamir) {
      // console.log("Success response:", Object.values(getCiljeviData.entities || {}));
      
      setNamirnice(Object.values(getNamirData.entities || {}))
      // console.log('Namirnice: ', Object.values(getNamirData.entities || {}));

      // data objekat je dobar response message
      // const successMessage = getCiljeviData?.message
    }

    if (isErrorGetNamir) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      const errorMessage = getNamirError?.data?.message
      alert(errorMessage);
    }
  }, [isSuccessGetNamir, isErrorGetNamir, getNamirError, getNamirData]);

  //Add namirnica
  useEffect(() => {
    if (isSuccessAddNamir) {
      alert(dataAddNamir.message.toString());
      window.location.reload();   //Da li da ostavim ovako ?
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorAddNamir) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorAddNamir?.data?.message);
    }
  }, [isSuccessAddNamir, isErrorAddNamir, errorAddNamir, dataAddNamir]);

  //Update namirnica
  useEffect(() => {
    if (isSuccessUpdateNamir) {
      alert(dataUpdateNamir.message.toString());
      window.location.reload();   //Da li da ostavim ovako ?
      // setPrimCiljNaziv('')
      // console.log(dataAddCilj.message.toString())
    }

    if (isErrorUpdateNamir) {
      // console.log("Error object:", error);

      // error objekat je kada nam posalje error poruke
      alert(errorUpdateNamir?.data?.message);
    }
  }, [isSuccessUpdateNamir, isErrorUpdateNamir, errorUpdateNamir, dataUpdateNamir]);

  //Del Namirnica
  useEffect(() => {
    if (isSuccessDelNamir) {
      alert(dataDelNamir);
      // console.log('delleted', dataDelCilj)
    }
  
    if (isErrorDelNamir) {
      alert(errorDelNamir?.data?.message);
    }
  }, [isSuccessDelNamir, isErrorDelNamir, errorDelNamir, dataDelNamir]);

  //Get Ishrana names
  useEffect(() => {
    if (isSuccessGetIshName) {
      // Ispis odgovora iz API-ja u konzoli
      // console.log("Podaci o ishranama (getIshNameData):", getIshNameData);
      
      // Proveri i prilagodi postavljanje availableIshrane
      if (Array.isArray(getIshNameData)) {
        setAvailableIshrane(getIshNameData); // Ako je getIshNameData niz ishrana
      } else if (getIshNameData && getIshNameData.entities) {
        setAvailableIshrane(Object.values(getIshNameData.entities)); // Ako koristiš strukturu sa entities
      } else {
        setAvailableIshrane([]); // Ako podaci nisu dostupni, postavi prazan niz
      }
    }
  
    if (isErrorGetIshName) {
      const errorMessage = getIshNameError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetIshName, isErrorGetIshName, getIshNameError, getIshNameData]);

  //Get Spec cilj names
  // useEffect(() => {
  //   if (isSuccessGetSpecCiljName) {
  //     if (Array.isArray(getSpecCiljNameData)) {
  //       setAvailableCiljevi(getSpecCiljNameData);
  //     } else if (getSpecCiljNameData && getSpecCiljNameData.entities) {
  //       setAvailableCiljevi(Object.values(getSpecCiljNameData.entities));
  //     } else {
  //       setAvailableCiljevi([]);
  //     }
  //   }
  
  //   if (isErrorGetSpecCiljName) {
  //     const errorMessage = getSpecCiljNameError?.data?.message;
  //     alert(errorMessage);
  //   }
  // }, [isSuccessGetSpecCiljName, isErrorGetSpecCiljName, getSpecCiljNameError, getSpecCiljNameData]);
  useEffect(() => {
    if (isSuccessGetSpecCiljName) {
      // console.log("Specijalni ciljevi:", getSpecCiljNameData);
    }
    if (isErrorGetSpecCiljName) {
      const errorMessage = getSpecCiljNameError?.data?.message;
      alert(errorMessage);
    }
  }, [isSuccessGetSpecCiljName, isErrorGetSpecCiljName, getSpecCiljNameError, getSpecCiljNameData]);
  
  const handleCiljChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setOdabraniCiljevi((prev) => [...prev, value]); // Dodaj cilj
    } else {
      setOdabraniCiljevi((prev) => prev.filter((cilj) => cilj !== value)); // Ukloni cilj
    }
  };

  // useEffect(() => {
  //   console.log("Dostupne ishrane:", odabraniCiljevi); // Ispis dostupnih ishrana
  // }, [odabraniCiljevi]);

  //Za checkiranje pri otvaranju popupa za novu naminicu
  useEffect(() => {
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      if (!editNamirnicaId) {
        // Automatski čekiraj sve kada se kreira nova namirnica
        setCheckedItems(getSpecCiljNameData.reduce((acc, cilj) => {
          acc[cilj._id] = true;
          return acc;
        }, {}));
  
        setCheckedItemsIsh(getIshNameData.reduce((acc, ishrana) => {
          acc[ishrana._id] = true;
          return acc;
        }, {}));
      }
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen, editNamirnicaId, getSpecCiljNameData, getIshNameData]);


  const grupeOpcije = [
    "Voće",
    "Povrće",
    "Orašasti Plodovi i Semenke",
    "Žitarice",
    "Mlečni Proizvodi",
    "Meso, Riba, Jaja",
    "Ulja, Masti i Šećeri",
    "Pića",
  ];

  const podtipoviOpcije = {
    Voće: ["Citrus", "Bobičasto", "Kostunjicavo", "Tropsko", "Jabuke i Kruške", "Lubenica"],
    Povrće: ["Lisnato", "Korenito", "Paprike i Paradajz", "Tikve", "Lukvičasto", "Mahunarke"],
    "Orašasti Plodovi i Semenke": ["Orašasti Plodovi", "Semenke"],
    Žitarice: ["Proizvodi od Celovitih Žitarica", "Celovite", "Rafinisane"],
    "Mlečni Proizvodi": ["Mleko", "Jogurt", "Sirenje", "Kiselo mleko", "Pavlaka i maslac"],
    "Meso, Riba, Jaja": ["Crveno meso", "Belo meso", "Riba i Morski Plodovi", "Prerađevine", "Jaja"],
    "Ulja, Masti i Šećeri": ["Šećeri i zaslađivači", "Maslac i margarin", "Biljna ulja"],
    Pića: ["Bezalkoholna pića", "Alkohol", "Sokovi", "Kafa i Čaj"],
  };

  const handleGrupaChange = (event) => {
    setGrupa(event.target.value);
    setPodtip(""); // Reset podtip kad promenimo grupu
  };

  const handleIshraneChange = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setOdabraneIshrane([...odabraneIshrane, value]);
    } else {
      setOdabraneIshrane(odabraneIshrane.filter((ishrana) => ishrana !== value));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // const updatedNamirnica = {
    //   id: editNamirnicaId !== null ? editNamirnicaId : namirnice.length + 1,
    //   naziv,
    //   grupa,
    //   podtip,
    //   laktoza,
    //   gluten,
    //   alergen,
    //   ishrane: odabraneIshrane,
    // };

    if (editNamirnicaId !== null) {
      // setNamirnice(namirnice.map((n) => (n.id === editNamirnicaId ? updatedNamirnica : n)));  //Ovde bi trebalo da saljem da se updejtuje namirnica 
      if (!grupa || !podtip || !naziv) {
        alert("Molimo Vas unesite sve parametre");
        return;
      }
    
      try {
        //checkedItemsIsh i checkedItems su id-ijevi(checkboxovi) sa odabranim ishranama i specificnim ciljevima
        let odbIsh = Object.keys(checkedItemsIsh).filter(key => checkedItemsIsh[key] === true);
        let odbCilj = Object.keys(checkedItems).filter(key => checkedItems[key] === true);
        await updateNamir({ IdNam, grupa, podtip, naziv, gluten, alergen, laktoza, odabraneIshrane: odbIsh, odabraniClijevi: odbCilj });
      } catch (err) {
        console.error("Error occurred:", err);
      }

    } else {
      // setNamirnice([...namirnice, updatedNamirnica]);   //Ovde bi trebalo da saljem da se kreira nova namirnica
      if (!grupa || !podtip || !naziv) {
        alert("Molimo Vas unesite sve parametre");
        return;
      }
    
      try {
        //checkedItemsIsh i checkedItems su id-ijevi(checkboxovi) sa odabranim ishranama i specificnim ciljevima
        let odbIsh = Object.keys(checkedItemsIsh).filter(key => checkedItemsIsh[key] === true);
        let odbCilj = Object.keys(checkedItems).filter(key => checkedItems[key] === true);
        await addNamir({ grupa, podtip, naziv, gluten, alergen, laktoza, odabraneIshrane: odbIsh, odabraniClijevi: odbCilj  });
      } catch (err) {
        console.error("Error occurred:", err);
      }
    }

    setIsPopupOpen(false); // Zatvori popup nakon unosa ili izmene
    resetForm(); // Resetuj formu
  };

  //here
  const togglePopup = () => { //Ovde bi morao da opet fetchujem ciljeveNames i ishraneNames 
    resetForm(); // Resetuj formu pri otvaranju popupa za novu namirnicu
    setIsPopupOpen(true); // Otvori popup
    setOdabraneIshrane(availableIshrane); // Automatski checkiraj sve ishrane
    setOdabraniCiljevi([]);
    // setSelectedIds([])
    // setSelectedIdsIsh([])
    setCheckedItems({})
    setCheckedItemsIsh({})

    // Checkira sve ishrane
    setOdabraneIshrane(availableIshrane.map((ishrana) => ishrana._id));
    // Checkira sve specifične ciljeve
    setOdabraniCiljevi(availableCiljevi.map((cilj) => cilj._id));
    
    // setIdNam(namirnice.find(item => item.naziv === naziv)._id)
  };

  const resetForm = () => {
    setIdNam("");
    setNaziv("");
    setGrupa("");
    setPodtip("");
    setLaktoza(false);
    setGluten(false);
    setAlergen(false);
    setOdabraneIshrane([]);
    setOdabraniCiljevi([]);
    setEditNamirnicaId(null); // Resetuj ID da bi popup znao da kreiramo novu namirnicu
  };


  //Za spec ciljeve odabir, selectedIds je lista odabranih id-ijeva specijalnih ciljeva za tu namirnicu
  const [selectedIds, setSelectedIds] = useState([]); // Za čuvanje ID-jeva
  // const [selectedNamirnica, setSelectedNamirnica] = useState('');
  const [checkedItems, setCheckedItems] = useState({});

  //Za ishrane odabir, selectedIdsIsh je lista odabranih id-ijeva ishrana za tu namirnicu 
  const [selectedIdsIsh, setSelectedIdsIsh] = useState([]); // Za čuvanje ID-jeva
  // const [selectedNamirnica, setSelectedNamirnica] = useState('');
  const [checkedItemsIsh, setCheckedItemsIsh] = useState({});

  // Funkcija za otvaranje popup-a za modifikaciju namirnice
  const handleEdit = (id) => {
    const namirnica = namirnice.find((n) => n._id === id); // Nađi namirnicu po id-ju

    setIdNam(id)
    if (namirnica) {
      // console.log("Odabrana namirnica:", namirnica);
      // console.log("Odabrani ciljevi namirnice:", namirnica.ciljevi);

      //Checkiranje spec ciljeva za naminice
      const newCheckedItems = {};
      if (namirnica.naziv) {
          getSpecCiljNameData?.forEach(item => {  //Ovde moram da napravim da ne uzima iz stare kolekcije koja je ovde 
              const hasNamirnica = item.namirnice.some(n => n.naziv === namirnica.naziv);
              newCheckedItems[item._id] = hasNamirnica;
          });
      }
      setCheckedItems(newCheckedItems);
      // Ažuriranje ID-jeva
      setSelectedIds(Object.keys(newCheckedItems).filter(key => newCheckedItems[key]));

      //Checkiranje ishrane za naminice
      const newCheckedItemsIsh = {};
      if (namirnica.naziv) {
          getIshNameData?.forEach(item => {
              const hasNamirnica = item.namirnice.some(n => n.naziv === namirnica.naziv);
              newCheckedItemsIsh[item._id] = hasNamirnica;
          });
      }
      setCheckedItemsIsh(newCheckedItemsIsh);
      // Ažuriranje ID-jeva
      setSelectedIdsIsh(Object.keys(newCheckedItemsIsh).filter(key => newCheckedItemsIsh[key]));


      setNaziv(namirnica.naziv);
      setGrupa(namirnica.grupa);
      setPodtip(namirnica.podtip);
      setLaktoza(namirnica.laktoza);
      setGluten(namirnica.gluten);
      setAlergen(namirnica.alergen);
      setOdabraneIshrane(namirnica.ishrane || []); // Postavi ishrane
      setOdabraniCiljevi(namirnica.ciljevi || []); // Postavi ciljeve za checkboxove 671f5f195997900563cea820
      setEditNamirnicaId(id); // Postavi ID da popup zna da se radi o izmeni
      setIsPopupOpen(true); // Otvori popup za izmenu
    }
  };
  

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setIsPopupOpen(false);
    }
  };

  //Proba
  // useEffect(() => {
  //   console.log('Odabrane ishrane: ', odabraneIshrane)
  // }, [odabraneIshrane]);

  //Chekiramo sve odma
  useEffect(() => {
    if (isSuccessGetIshName && getIshNameData) {
      setOdabraneIshrane(getIshNameData.map(ishrana => ishrana._id)); //Posle resetuj odabir u state-u
    }
  }, [isPopupOpen]);

  useEffect(() => {
    if (isPopupOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isPopupOpen]);

  const handleDelete = (id) => {
    // setNamirnicaZaBrisanje(id); // Postavi ID namirnice koja će se obrisati
    let namir = namirnice.find((n) => n.id === id);
    setIdNam(namir._id);
    setIsModalOpen(true); // Otvori modal
  };

  const handleConfirmDelete = async () => {
    // setNamirnice(namirnice.filter((namirnica) => namirnica.id !== namirnicaZaBrisanje)); // Obrisi namirnicu ALI USTAVRI BACI FETCH ZA DELETE
    // console.log('id je idnam: ', IdNam)
    
    if(!IdNam){
      alert("Potreban je ID naminice");
    }

    try {
      await delNamir({ id: IdNam });
    } catch (err) {
      console.error("Error occurred:", err);
    }

    setIsModalOpen(false); 
    setNamirnicaZaBrisanje(null);
  };

  const closeModal = () => {
    setIsModalOpen(false); // Zatvori modal bez brisanja
    setNamirnicaZaBrisanje(null); // Resetuj namirnicu za brisanje
  };

  //Za Ciljeve getIshNameData
  const handleCheckboxChange = (id) => {
    const newCheckedItems = {
        ...checkedItems,
        [id]: !checkedItems[id]
    };
    setCheckedItems(newCheckedItems);

    // Ažuriranje ID-jeva
    setSelectedIds(Object.keys(newCheckedItems).filter(key => newCheckedItems[key]));
  };

  //Za Ishrane 
  const handleCheckboxChangeIsh = (id) => {
    const newCheckedItems = {
        ...checkedItemsIsh,
        [id]: !checkedItemsIsh[id]
    };
    setCheckedItemsIsh(newCheckedItems);

    // Ažuriranje ID-jeva
    setSelectedIdsIsh(Object.keys(newCheckedItems).filter(key => newCheckedItems[key]));
  };

  return (
    <div>
      {/* Dugme za otvaranje popupa za novu namirnicu */}
      <div className="flex justify-end"> 
        <button onClick={togglePopup} className="mt-3 mx-3 bg-indigo-500 text-white py-2 px-4 rounded-lg hover:bg-indigo-600">Kreiraj Namirnicu</button>
      </div>
      
      {/* Modal za potvrdu brisanja */}
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <div className="relative p-5 border w-96 shadow-lg rounded bg-white">
            <div className="mt-3 text-center">
              <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100">
                <svg
                  className="h-6 w-6 text-yellow-600"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              </div>
              <h3 className="text-lg leading-6 font-medium text-gray-900 mt-5">
                Upozorenje
              </h3>
              <div className="mt-2 px-7 py-3">
                <p className="text-sm text-gray-500">
                  Da li ste sigurni da želite izbrisati ovu namirnicu?
                </p>
              </div>
              <div className="items-center px-4 py-3">
                <button
                  onClick={handleConfirmDelete}
                  className="px-4 py-2 bg-yellow-500 text-white text-base font-medium rounded w-full shadow-sm hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                >
                  Da
                </button>
                <button
                  onClick={closeModal}
                  className="mt-3 px-4 py-2 bg-white text-gray-800 text-base font-medium rounded w-full shadow-sm border border-gray-300 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
                >
                  Ne
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Popup za kreiranje ili izmenu namirnice */}
      {isPopupOpen && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex items-center justify-center z-50">
          <div ref={popupRef} className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full max-h-screen overflow-y-auto">
            <h2 className="text-xl font-bold mb-4">{editNamirnicaId ? "Izmeni Namirnicu" : "Kreiraj Namirnicu"}</h2>
            <form onSubmit={handleSubmit}>
              {/* Grupa */}
              <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2">
                  Grupa: <span className="text-red-500">*</span>
                </label>
                <select
                  value={grupa}
                  onChange={handleGrupaChange}
                  className="w-full px-3 py-2 border rounded-lg"
                  required
                >
                  <option value="">Izaberi grupu</option>
                  {grupeOpcije.map((grupaOpcija) => (
                    <option key={grupaOpcija} value={grupaOpcija}>
                      {grupaOpcija}
                    </option>
                  ))}
                </select>
              </div>

              {/* Podtip */}
              {grupa && (
                <div className="mb-4">
                  <label className="block text-gray-700 font-bold mb-2">
                    Podtip: <span className="text-red-500">*</span>
                  </label>
                  <select
                    value={podtip}
                    onChange={(e) => setPodtip(e.target.value)}
                    className="w-full px-3 py-2 border rounded-lg"
                    required
                  >
                    <option value="">Izaberi podtip</option>
                    {podtipoviOpcije[grupa]?.map((podtipOpcija) => (
                      <option key={podtipOpcija} value={podtipOpcija}>
                        {podtipOpcija}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              {/* Naziv */}
              <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2">
                  Naziv: <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={naziv}
                  onChange={(e) => setNaziv(e.target.value)}
                  className="w-full px-3 py-2 border rounded-lg"
                  required
                />
              </div>

              {/* Laktoza, Gluten */}
              <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2">Svojstva:</label>
                <div className="flex space-x-4">
                  <div>
                    <label>
                      <input
                        type="checkbox"
                        checked={laktoza}
                        onChange={(e) => setLaktoza(e.target.checked)}
                        className="mr-2"
                      />
                      Laktoza
                    </label>
                  </div>
                  <div>
                    <label>
                      <input
                        type="checkbox"
                        checked={gluten}
                        onChange={(e) => setGluten(e.target.checked)}
                        className="mr-2"
                      />
                      Gluten
                    </label>
                  </div>
                </div>
              </div>

              {/* Alergen */}
              <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2 text-red-500">
                  <span className="text-red-500">*</span> Alergen:
                </label>
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={alergen}
                    onChange={(e) => setAlergen(e.target.checked)}
                    className="mr-2"
                  />
                  <span className="text-red-600 font-bold">Alergen</span>
                </div>
              </div>

              {/* Ishrane sa checkboxovima */}
              <div className="mb-4"> 
                <label className="block text-gray-700 font-bold mb-2">Ishrane:</label>
                {isSuccessGetIshName && getIshNameData && (
                  <div className="grid grid-cols-2 gap-2">
                    {Array.isArray(getIshNameData) && getIshNameData.length > 0 ? (
                      getIshNameData.map((ishrana) => (
                        <div key={ishrana._id} className="flex items-center">
                          {/* <input
                            type="checkbox"
                            value={ishrana._id}
                            checked={Array.isArray(odabraneIshrane) && odabraneIshrane.includes(ishrana._id)}
                            onChange={handleIshraneChange}
                            className="mr-2"
                          /> */}
                          <input
                            type="checkbox"
                            checked={checkedItemsIsh[ishrana._id] || false}
                            onChange={() => handleCheckboxChangeIsh(ishrana._id)}
                            className="mr-2"
                          />
                          <span>{ishrana.naziv}</span>
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-center">
                        Nema dostupnih ishrana.
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2">Ishrane:</label>
                {isSuccessGetIshName && getIshNameData && (
                  <div className="grid grid-cols-2 gap-2">
                    {Array.isArray(getIshNameData) && getIshNameData.length > 0 ? (
                      getIshNameData.map((ishrana) => (
                        <div key={ishrana._id} className="flex items-center">
                          <input
                            type="checkbox"
                            value={ishrana._id}
                            checked={odabraneIshrane.includes(ishrana._id)}
                            onChange={handleIshraneChange}
                            className="mr-2"
                          />
                          <span>{ishrana.naziv}</span>
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-center">Nema dostupnih ishrana.</div>
                    )}
                  </div>
                )}
              </div> */}
              
              {/* here */}
              <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2">Specifični ciljevi:</label>
                {isSuccessGetSpecCiljName && getSpecCiljNameData && (
                  <div className="grid grid-cols-2 gap-2">
                    {Array.isArray(getSpecCiljNameData) && getSpecCiljNameData.length > 0 ? (
                      getSpecCiljNameData.map((cilj) => (
                        <div key={cilj._id} className="flex items-center">
                          {/* <input
                            type="checkbox"
                            value={cilj._id}
                            checked={odabraniCiljevi.includes(cilj._id)} // Checkira ciljeve koji su deo namirnice
                            onChange={handleCiljChange} // Ažurira state kada se čekira/odčekira
                            className="mr-2"
                          /> */}
                          <input
                            type="checkbox"
                            checked={checkedItems[cilj._id] || false}
                            onChange={() => handleCheckboxChange(cilj._id)}
                            className="mr-2"
                          />
                          <span>{cilj.naziv}</span>
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-center">Nema dostupnih ciljeva.</div>
                    )}
                  </div>
                )}
              </div>
              {/* <div className="mb-4">
                <label className="block text-gray-700 font-bold mb-2">Specifični ciljevi:</label>
                {isSuccessGetSpecCiljName && getSpecCiljNameData && (
                  <div className="grid grid-cols-2 gap-2">
                    {Array.isArray(getSpecCiljNameData) && getSpecCiljNameData.length > 0 ? (
                      getSpecCiljNameData.map((cilj) => (
                        <div key={cilj._id} className="flex items-center">
                          <input
                            type="checkbox"
                            value={cilj._id}
                            checked={odabraniCiljevi.includes(cilj._id)}
                            onChange={handleCiljChange}
                            className="mr-2"
                          />
                          <span>{cilj.naziv}</span>
                        </div>
                      ))
                    ) : (
                      <div className="px-4 py-2 text-center">Nema dostupnih ciljeva.</div>
                    )}
                  </div>
                )}
              </div> */}








              


              <button
                type="submit"
                className="w-full bg-indigo-500 text-white py-2 px-4 rounded-lg hover:bg-indigo-600"
              >
                {editNamirnicaId ? "Sačuvaj Izmene" : "Sačuvaj Namirnicu"}
              </button>
            </form>
          </div>
        </div>
      )}

      {/* Tabela sa namirnicama */}
      <div className="overflow-auto h-full mt-6">
        <table className="min-w-full bg-white border border-gray-200">
          <thead className="bg-gray-100 sticky top-0 z-10"> {/* Sticky z-10 za vidljivost */}
            <tr>
              <th className="px-4 py-2 border">Grupa</th>
              <th className="px-4 py-2 border">Podtip</th>
              <th className="px-4 py-2 border">Naziv</th>
              <th className="px-4 py-2 border">Laktoza</th>
              <th className="px-4 py-2 border">Gluten</th>
              <th className="px-4 py-2 border">Alergen</th>
              {/* <th className="px-4 py-2 border">Ishrane</th> */}
              {availableIshrane.length > 0 ? (
                availableIshrane.map((ishrana) => (
                  <th key={ishrana._id || ishrana} className="px-4 py-2 border">
                    {ishrana.naziv || ishrana}
                  </th>
                ))
              ) : (
                <th className="px-4 py-2 border">Nema dostupnih ishrana</th>
              )}
              <th className="px-4 py-2 border">Akcije</th>
            </tr>
          </thead>
          
          {/* {isSuccessGetNamir && getNamirData && ( */}
          <tbody>
            {Array.isArray(namirnice) && namirnice.length > 0 ? (
              namirnice.map((namirnica) => (
                <tr key={namirnica._id}>
                  <td className="px-4 py-2 border">{namirnica.grupa}</td>
                  <td className="px-4 py-2 border">{namirnica.podtip}</td>
                  <td className="px-4 py-2 border text-indigo-600 font-bold hover:underline cursor-pointer" onClick={() => handleEdit(namirnica.id)}>{namirnica.naziv}</td>
                  <td className="px-4 py-2 border">{namirnica.laktoza ? "Da" : "Ne"}</td>
                  <td className="px-4 py-2 border">{namirnica.gluten ? "Da" : "Ne"}</td>
                  <td className="px-4 py-2 border">{namirnica.alergen ? "Da" : "Ne"}</td>
                  {/* Ukljuci ovo kad budes imao namirnice u ishranama */}
                  {availableIshrane.map((ishrana) => (
                    <td key={ishrana._id || ishrana} className="px-4 py-2 border text-center">
                      <input
                        type="checkbox"
                        checked={namirnica.ishrane.includes(ishrana.naziv || ishrana)}
                        readOnly
                      />
                    </td>
                  ))}
                  <td className="px-4 py-2 border text-center">
                    <button
                      onClick={() => handleDelete(namirnica._id)}
                      className="text-red-500 font-bold"
                    >
                      Izbriši
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="px-4 py-2 border text-center">
                  Nema dostupnih namirnica.
                </td>
              </tr>
            )}
          </tbody>
         {/* )} */}

        </table>
      </div>
    </div>
  );
};

export default NamirnicaForm;